{
  "AGENT_BOTS": {
    "HEADER": "Boti",
    "LOADING_EDITOR": "Nalaganje urejevalnika ...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try. You can manage your bots from this page or create new ones using the 'Add Bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Izberite agentskega bota",
      "DESC": "Dodelite Agentskega Bota v svoj nabiralnik. Ti lahko vodijo začetne pogovore in jih po potrebi prenesejo na agenta v živo.",
      "SUBMIT": "Posodobi",
      "DISCONNECT": "Odklopi bota",
      "SUCCESS_MESSAGE": "Agentski bot je bil uspešno posodobljen.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Povezava z agentskega bota je bila uspešno prekinjena.",
      "ERROR_MESSAGE": "Agentskega bota ni bilo mogoče posodobiti. Prosimo poskusite ponovno.",
      "DISCONNECTED_ERROR_MESSAGE": "Ni bilo mogoče prekiniti povezave z agentskim botom. Prosimo poskusite ponovno.",
      "SELECT_PLACEHOLDER": "Izberi bota"
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "Prekliči",
      "API": {
        "SUCCESS_MESSAGE": "Bot je bil uspešno dodan.",
        "ERROR_MESSAGE": "Bota ni bilo mogoče dodati. Poskusite znova pozneje."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Add Bot' button.",
      "LOADING": "Pridobivanje botov ...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Details",
        "URL": "Webhook URL",
        "ACTIONS": "Actions"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "TITLE": "Izbriši bota",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Yes, Delete",
        "NO": "No, Keep"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot uspešno izbrisan.",
        "ERROR_MESSAGE": "Bota ni bilo mogoče izbrisati. Prosimo poskusite ponovno."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Uredi",
      "TITLE": "Uredi bota",
      "API": {
        "SUCCESS_MESSAGE": "Bot je bil uspešno posodobljen.",
        "ERROR_MESSAGE": "Bota ni bilo mogoče posodobiti. Prosimo poskusite ponovno."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Access Token",
      "DESCRIPTION": "Copy the access token and save it securely",
      "COPY_SUCCESSFUL": "Access token copied to clipboard",
      "RESET_SUCCESS": "Access token regenerated successfully",
      "RESET_ERROR": "Unable to regenerate access token. Please try again"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Ime bota",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Zahtevano je ime bota"
      },
      "DESCRIPTION": {
        "LABEL": "Description",
        "PLACEHOLDER": "Kaj počne ta bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Zahtevano je ime bota",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "Cancel",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot"
    }
  }
}
